import { useCandidatContext } from 'contexts/CandidatContext';
import React from 'react';
import { Job } from '../types/types';
import moment from 'moment';
import { useRouter } from 'next/navigation';
import { useTranslation } from 'react-i18next';
import LucideIcon from 'components/common/LucideIcon';

interface CardPostProps {
  job: Job;
}
const CardPost: React.FC<CardPostProps> = ({ job }) => {
  const { interfaceContenu } = useCandidatContext();
  const { t } = useTranslation();
  const router = useRouter();

  const handleOpenPost = (): void => {
    router.push(`/candidat/post/${job.id}`);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>): void => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleOpenPost();
    }
  };

  return (
    <div
      className="post-card"
      onClick={handleOpenPost}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      style={{ cursor: 'pointer' }}
    >
      <div>
        <h1 className="post-card-tite">{job.title}</h1>

        <div className="post-card-info">
          {job.createDate && (
            <small className="item text-s">
              <LucideIcon
                name="Calendar"
                size={16}
                strokeWidth={2}
                color={interfaceContenu?.color}
              />
              <div>{moment(job.createDate).format('L')}</div>
            </small>
          )}
          {job.address && (
            <small className="item text-s">
              <LucideIcon
                name="MapPin"
                size={16}
                strokeWidth={2}
                color={interfaceContenu?.color}
              />
              <div>{job.address}</div>
            </small>
          )}

          {job.type && (
            <small className="item text-s">
              <LucideIcon
                name="Briefcase"
                size={16}
                strokeWidth={2}
                color={interfaceContenu?.color}
              />
              <div>{t(job.type)}</div>
            </small>
          )}
        </div>
      </div>
      <button
        type="button"
        className="show-post"
        aria-label={t('See.more')}
        title={t('See.more')}
        onClick={(event) => {
          event.stopPropagation();
          handleOpenPost();
        }}
      >
        <LucideIcon name="ArrowRight" size={16} strokeWidth={2.2} />
      </button>
    </div>
  );
};

export default CardPost;
